if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  const initFeaturedCollection = () => {
    if (Alpine.store('xFeaturedCollectionInit')) return;
    Alpine.store('xFeaturedCollectionInit', true);
    Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
      sectionId: sectionId,
      pageParam: pageParam,
      currentTab: 1,
      loading: true,
      loaded: [],
      select(index) {
        this.currentTab = index;
      },
      loadData(index) {
        const selectedPage = index - 1;
        if (this.loaded.includes(selectedPage)) return;

        const contentId = `x-fc-${this.sectionId}-${index}`;
        if (document.getElementById(contentId)) {
          this.loaded.push(selectedPage);
          return;
        }

        this.loading = true;
        const url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
        fetch(url, {
          method: 'GET'
        }).then(
          response => response.text()
        ).then(responseText => {
          const html = (new DOMParser()).parseFromString(responseText, 'text/html');
          const newContent = html.getElementById(contentId);
          if (newContent && !document.getElementById(contentId)) {
            container.appendChild(newContent);
            this.loaded.push(selectedPage);
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      scrollIntoView(element) {
        const scrollableContainer = element.closest('.overflow-x-auto'); 
        const elementPosition = element.offsetLeft;

        scrollableContainer.scroll({
          left: elementPosition,
          behavior: 'smooth'
        });
      }
    }));
  };

  if (window.Alpine) {
    initFeaturedCollection();
  } else {
    document.addEventListener('alpine:init', initFeaturedCollection);
  }
}